import { render, staticRenderFns } from "./deviceSerial.vue?vue&type=template&id=0545c7ba"
import script from "./deviceSerial.vue?vue&type=script&lang=js"
export * from "./deviceSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports